export default "__VITE_ASSET__c16e1fce__"